import { AES_KEY, TOKEN_STORAGE_KEY } from "@/utils/global-constants";
import { cryptoUtil } from "@/utils/crypto/crypto";
import { SecureStorageService } from "@sadtx/secure-storage";

export const secureStorage = new SecureStorageService(
  import.meta.env.VITE_SECRET_KEY!,
  async (data: string, key: string) => cryptoUtil.encrypt(data, key),
  async (data: string, key: string) => cryptoUtil.decrypt(data, key),
);

export const tokenStorage = {
  async clearTokens(): Promise<void> {
    if (typeof localStorage !== "undefined") {
      await secureStorage.removeItem(localStorage, TOKEN_STORAGE_KEY);
    }
  },

  async setAesKey(key: string): Promise<void> {
    await secureStorage.setItem(sessionStorage, AES_KEY, key);
  },

  async getAesKey(): Promise<string | null> {
    const value = await secureStorage.getItem(sessionStorage, AES_KEY);
    return typeof value === "string" ? value : null;
  },

  async clearAesKey(): Promise<void> {
    await secureStorage.removeItem(sessionStorage, AES_KEY);
  },
};
